<template>
  <div :style="wrapperStyle" :role="fieldLabel ? 'group' : undefined" :aria-labelledby="fieldLabel ? labelId : undefined">
    <div v-if="fieldLabel" class="form-field-label" :id="labelId">{{ fieldLabel }}</div>
    <b-form-checkbox
      :id="uniqueTitle"
      :name="uniqueTitle"
      :disabled="isReadonly"
      :aria-describedby="describedBy"
      :class="{ 'form-field-readonly': isReadonly }"
      @change="onChange"
    >
      {{ checkedDescription }}
    </b-form-checkbox>
  </div>
</template>

<script>
import { inject, computed } from 'vue'
import { formattingToStyle } from '../../lib/client-rule-evaluator'

export default {
  props: ['checkedDescription', 'uniqueTitle', 'fieldLabel', 'description'],
  setup (props) {

    const formFormatting = inject('formFormatting', null)
    const formReadonly = inject('formReadonly', null)
    const updateFormValue = inject('updateFormValue', null)

    const wrapperStyle = computed(() => {
      if (!formFormatting || !props.uniqueTitle) return {}
      const fmt = formFormatting[props.uniqueTitle]
      return fmt ? formattingToStyle(fmt) : {}
    })

    const isReadonly = computed(() => {
      if (!formReadonly || !props.uniqueTitle) return false
      return !!formReadonly[props.uniqueTitle]
    })

    const labelId = computed(() => `${props.uniqueTitle}-label`)

    const describedBy = computed(() => {
      return props.description ? `${props.uniqueTitle}-description` : undefined
    })

    return { formFormatting, formReadonly, updateFormValue, wrapperStyle, isReadonly, labelId, describedBy }
  },
  methods: {
    onChange (checked) {
      if (this.updateFormValue) {
        this.updateFormValue(this.uniqueTitle, checked)
      }
    }
  }
}
</script>
